// pages/DynamicDoc.jsx — render tab Documentation yang isinya dari backend (/api/docs/content/:key).
// Isi = HTML milik admin di backend/docs/<key>.html; diubah tanpa build frontend.
// Bahasa: elemen data-lang="en" / data-lang="id" — yang tidak dipilih disembunyikan.
import React, { useState, useEffect } from 'react';
import { api } from '../context/AuthContext';
import { useLang } from '../context/LanguageContext';

export default function DynamicDoc({ docKey }) {
  const { lang: appLang } = useLang();
  const [lang, setLang] = useState(appLang === 'id' ? 'id' : 'en');
  const [doc, setDoc] = useState(null);
  const [err, setErr] = useState('');

  useEffect(() => { setLang(appLang === 'id' ? 'id' : 'en'); }, [appLang]);
  useEffect(() => {
    let alive = true;
    setDoc(null); setErr('');
    api.get(`/api/docs/content/${docKey}`)
      .then((r) => { if (alive) setDoc(r.data); })
      .catch((e) => { if (alive) setErr((e.response && e.response.data && e.response.data.error) || e.message); });
    return () => { alive = false; };
  }, [docKey]);

  const other = lang === 'en' ? 'id' : 'en';
  return (
    <div className={`dyn-doc dyn-doc-${lang}`}>
      <style>{`.dyn-doc-${lang} [data-lang="${other}"]{display:none !important}`}</style>
      <div className="mb-3 flex items-center justify-between gap-2">
        <span className="text-xs text-gray-500">
          {doc && doc.updatedAt ? `${lang === 'id' ? 'Diperbarui' : 'Updated'} ${new Date(doc.updatedAt).toLocaleString(lang === 'id' ? 'id-ID' : 'en-US')}` : ''}
        </span>
        <div className="flex overflow-hidden rounded border border-gray-300 text-xs">
          {['en', 'id'].map((l) => (
            <button key={l} type="button" onClick={() => setLang(l)}
              className={`px-2 py-1 font-medium ${lang === l ? 'bg-sky-500 text-white' : 'text-gray-600 hover:bg-gray-100'}`}>{l.toUpperCase()}</button>
          ))}
        </div>
      </div>
      {err && <div className="rounded border border-red-200 bg-red-50 p-3 text-sm text-red-700">{err}</div>}
      {!doc && !err && <div className="text-sm text-gray-500">Loading…</div>}
      {doc && <div dangerouslySetInnerHTML={{ __html: doc.html }} />}
    </div>
  );
}
